/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const switchOrgRequestV4Schema = z.object({
  orgId: z
    .string()
    .nullish()
    .describe(
      'The coded org/context id to switch into (an orgId from me/roles; for an internship the myInternships internId). NULL = the Edy365 entry; coded all-zeros = the individual account.'
    )
    .meta({ examples: ['kJ8v2Qm7xR1a'] }),
})
